import { useState, createContext } from "react";

export const ModalContext = createContext();

export const ModalProvider = (props) => {
  const [modalKey, setModalKey] = useState(null);
  const [modalProps, setModalProps] = useState(null);
  const [modalData, setModalData] = useState(null);

  const showModal = (modalKey, props = null, data = null) => {
    setModalProps(props);
    setModalKey(modalKey);
    setModalData(data);
  };

  const hideModal = () => {
    setModalKey(null);
    setModalProps(null);
    setModalData(null);
  };

  const state = {
    modalKey,
    modalProps,
    modalData,
  };

  return (
    <ModalContext.Provider
      value={{
        modalKey: state.modalKey,
        modalProps: state.modalProps,
        modalData: state.modalData,
        showModal,
        hideModal,
      }}
    >
      {props.children}
    </ModalContext.Provider>
  );
};
